// extracted by mini-css-extract-plugin
export default {"suggestion-body-header":"P1V3wVku","autocomplete":"LoDvgMei","suggestions-list":"rfLcAOOT","suggestions-options":"ixyhMbFH","suggestions-none":"Osr4nlTL"};